// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* components/styles/Legend.css */

/* Este container continua o mesmo */
.legend-column-left {
  position: absolute;
  top: 30px;
  left: 10px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px; 
}

/* LEGENDA INDIVIDUAL */
.legend-container {
  background-color: white;

  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  font-family: Arial, sans-serif;
  font-size: 8px;
  overflow-y: auto;
  /* Adicione uma largura para a caixa não ficar estranha ao minimizar */
  width: 170px;
}

/* --- NOVOS ESTILOS PARA O HEADER --- */
.legend-header {
  display: flex;
  justify-content: space-between; 
  align-items: center;
  padding: 10px; /* ADICIONADO PADDING AQUI */
  cursor: pointer; /* ADICIONADO CURSOR */
}
.legend-header:hover {
  background-color: #f7f7f7;
}
/* --- ESTILO DO TÍTULO ATUALIZADO --- */
.legend-container h4 {
  margin: 0; /* Remove margens */
  border-bottom: none; /* Remove a borda antiga */
  padding-bottom: 0; /* Remove padding antigo */
  font-size: 10px; /* Um pouco maior para ser o título */
  flex-grow: 1; /* Ocupa o espaço disponível */
}

/* --- NOVO ESTILO PARA O BOTÃO INDIVIDUAL --- */
.legend-minimize-indicator {
  background: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 20px;
  height: 20px;
  line-height: 18px; 
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  /* cursor: pointer; FOI REMOVIDO (agora está no header) */
  padding: 0;
  margin-left: 10px; 
  flex-shrink: 0; 
}

.legend-minimize-btn:hover {
  background: #e0e0e0;
}

/* --- ESTILO DA LISTA (UL) ATUALIZADO --- */
.legend-container ul {
  list-style: none;
  padding: 0 10px 10px 10px; /* Padding para o conteúdo */
  margin: 0;
  margin-top: 0; /* Ajustado */
  padding-top: 8px; /* Ajustado */
  border-top: 1px solid #ddd;
}

/* --- ESTES CONTINUAM IGUAIS --- */
.legend-container li {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.legend-color-box {
  width: 20px;
  height: 10px;
  opacity: 0.7;
  margin-right: 8px;
  border: 1px solid #cccccc50;
  border-radius: 4px;
}

/* --- REMOVA O BOTÃO ANTIGO --- */
/* Apague este seletor .legend-toggle-btn do seu CSS */
/* .legend-toggle-btn {
  ...
} 
*/

.legend-toggle-btn {
  background-color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 8px;
  cursor: pointer;
  font-weight: bold;
  font-family: Arial, sans-serif;
  font-size: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  width: 100px; /* Faz o botão ocupar a largura da legenda */
}

.legend-toggle-btn:hover {
  background-color: #f4f4f4;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Legend.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,oCAAoC;AACpC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;;EAEvB,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,sEAAsE;EACtE,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa,EAAE,4BAA4B;EAC3C,eAAe,EAAE,sBAAsB;AACzC;AACA;EACE,yBAAyB;AAC3B;AACA,wCAAwC;AACxC;EACE,SAAS,EAAE,mBAAmB;EAC9B,mBAAmB,EAAE,0BAA0B;EAC/C,iBAAiB,EAAE,0BAA0B;EAC7C,eAAe,EAAE,qCAAqC;EACtD,YAAY,EAAE,8BAA8B;AAC9C;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yDAAyD;EACzD,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,yBAAyB,EAAE,4BAA4B;EACvD,SAAS;EACT,aAAa,EAAE,aAAa;EAC5B,gBAAgB,EAAE,aAAa;EAC/B,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC,sDAAsD;AACtD;;;CAGC;;AAED;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,YAAY,EAAE,4CAA4C;AAC5D;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* components/styles/Legend.css */\n\n/* Este container continua o mesmo */\n.legend-column-left {\n  position: absolute;\n  top: 30px;\n  left: 10px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: 10px; \n}\n\n/* LEGENDA INDIVIDUAL */\n.legend-container {\n  background-color: white;\n\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n  font-family: Arial, sans-serif;\n  font-size: 8px;\n  overflow-y: auto;\n  /* Adicione uma largura para a caixa não ficar estranha ao minimizar */\n  width: 170px;\n}\n\n/* --- NOVOS ESTILOS PARA O HEADER --- */\n.legend-header {\n  display: flex;\n  justify-content: space-between; \n  align-items: center;\n  padding: 10px; /* ADICIONADO PADDING AQUI */\n  cursor: pointer; /* ADICIONADO CURSOR */\n}\n.legend-header:hover {\n  background-color: #f7f7f7;\n}\n/* --- ESTILO DO TÍTULO ATUALIZADO --- */\n.legend-container h4 {\n  margin: 0; /* Remove margens */\n  border-bottom: none; /* Remove a borda antiga */\n  padding-bottom: 0; /* Remove padding antigo */\n  font-size: 10px; /* Um pouco maior para ser o título */\n  flex-grow: 1; /* Ocupa o espaço disponível */\n}\n\n/* --- NOVO ESTILO PARA O BOTÃO INDIVIDUAL --- */\n.legend-minimize-indicator {\n  background: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 20px;\n  height: 20px;\n  line-height: 18px; \n  text-align: center;\n  font-size: 14px;\n  font-weight: bold;\n  /* cursor: pointer; FOI REMOVIDO (agora está no header) */\n  padding: 0;\n  margin-left: 10px; \n  flex-shrink: 0; \n}\n\n.legend-minimize-btn:hover {\n  background: #e0e0e0;\n}\n\n/* --- ESTILO DA LISTA (UL) ATUALIZADO --- */\n.legend-container ul {\n  list-style: none;\n  padding: 0 10px 10px 10px; /* Padding para o conteúdo */\n  margin: 0;\n  margin-top: 0; /* Ajustado */\n  padding-top: 8px; /* Ajustado */\n  border-top: 1px solid #ddd;\n}\n\n/* --- ESTES CONTINUAM IGUAIS --- */\n.legend-container li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.legend-color-box {\n  width: 20px;\n  height: 10px;\n  opacity: 0.7;\n  margin-right: 8px;\n  border: 1px solid #cccccc50;\n  border-radius: 4px;\n}\n\n/* --- REMOVA O BOTÃO ANTIGO --- */\n/* Apague este seletor .legend-toggle-btn do seu CSS */\n/* .legend-toggle-btn {\n  ...\n} \n*/\n\n.legend-toggle-btn {\n  background-color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 5px 8px;\n  cursor: pointer;\n  font-weight: bold;\n  font-family: Arial, sans-serif;\n  font-size: 10px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.2);\n  width: 100px; /* Faz o botão ocupar a largura da legenda */\n}\n\n.legend-toggle-btn:hover {\n  background-color: #f4f4f4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
